import React, { useState, useEffect } from "react";

import { connect } from 'react-redux';
import { XMarkIcon } from '@heroicons/react/20/solid'
import { Actions as LEAVEADJUSTMENTACTIONS } from '../../../../store/actions/leaveAdjustmentActions';
import ImportLeaveAdjustmentRow from './ImportLeaveAdjustmentRow';
import { ArrowDownTrayIcon } from "@heroicons/react/20/solid";
import { CSVLink } from 'react-csv';
import { NotificationManager } from "react-notifications";

const ImportLeaveAdjustmentModal = ({
    isModalOpen,
    showImportModal,
    getLeaveAdjustmentImportTemplate,
    uploadFile,
    handleLeaveAdjustmentUpload,
    org,
    uploadKey,
    uploading,
    processing,
    uploadTemplate,
    uploadResults
}) => {

    const [file, setFile] = useState(false);
    const [replaceExisting, setReplaceExisting] = useState(false);
    const [errors, setErrors] = useState([["Row", "Type", "Message"]]);

    useEffect(() => {
        if (isModalOpen) getLeaveAdjustmentImportTemplate();
    }, [isModalOpen]);

    useEffect(() => {
        if (file && uploadResults) {
            setFile(null);
        }
        if (uploadResults.errors || uploadResults.warnings) {
            let newErrors = [["Row", "Type", "Message"]];
            uploadResults.processed.filter(i => i.error || i.warnings).map((item) => {
                if (item.error) {
                    newErrors.push([item.rowNumber, "Error", item.error.message]);
                } else if (item.warnings) {
                    item.warnings.map(i => {
                        newErrors.push([item.rowNumber, "Warning", i.message])
                    });
                }
            })
            setErrors(newErrors);
        }
    }, [uploadResults]);

    const selectUploadFile = (e) => {
        const file = e.target.files[0]; // accessing file
        // console.log('file', file);
        setFile(file); // storing file
        if (file?.name && !['xlsx', 'xls'].includes(file?.name?.split(".")[file?.name?.split(".").length - 1]?.toLowerCase())) {
            NotificationManager.error('Please upload a valid xlsx file.', 'Import Leave Adjustments');
            setFile(null);
        } else {
            uploadFile(file);
        }
    }

    const processUploadFile = () => {
        handleLeaveAdjustmentUpload({ uploadKey, org, replaceExisting });
    }

    const ImportLeaveStatus = () => {
        if (!uploadResults?.errors && !uploadResults?.processed) return (
            <div>
                <p>Here's how to import your entire leave in 3 easy steps: just download our ready-made Excel sheet template, paste in your data in the corresponding columns, and upload it back when you're done.</p>
                <p>
                    {(uploadTemplate &&
                        <a
                            target="_blank"
                            href={`${uploadTemplate}`}>
                            Download Template (.xlsx)
                        </a>
                    ) || <a>Loading...</a>}
                </p>
                <div className="row block buttons">
                    <label htmlFor="uploadLeave" className="btn btn-success pull-right" style={{ display: "inline-block", marginLeft: "10px" }}>
                        <i className="fa fa-upload"></i>&nbsp;{uploading ? "Uploading..." : "Upload File"}
                    </label>
                    <input style={{ display: 'none' }} id="uploadLeave" type="file" accept='.xlsx' onChange={selectUploadFile} />
                    {uploadKey &&
                        <>
                            <button
                                id="import_leave"
                                disabled={processing}
                                className="btn btn-default pull-right"
                                onClick={() => processUploadFile()}
                            >
                                {processing ? "Importing..." : "Start Import"}
                            </button>
                            <label style={{ marginLeft: "10px" }} forHTML="replaceExisting" className="css-input switch switch-sm switch-success inline" onClick={(e) => { e.stopPropagation(); e.preventDefault(); setReplaceExisting(!replaceExisting) }}>
                                <input id="replaceExisting" name="mode" type="checkbox" checked={replaceExisting} />
                                <span></span>
                                Replace leave adjustments if found
                            </label>
                        </>
                    }
                    <div className="clearfix" />
                </div>
                <div className="clearfix" />
            </div>
        )

        return (
            <div>
                {(uploadResults?.processed.length > 0 &&
                    <div style={{ marginBottom: 20 }}>
                        {uploadResults?.processed?.length - uploadResults?.errors} leave adjustment{uploadResults?.processed?.length - uploadResults?.errors != 1 ? "s were" : " was"} imported.
                    </div>
                ) || <></>}
                {(uploadResults?.errors &&
                    <div>
                        There {uploadResults.errors > 1 ? "were" : "was"} {uploadResults.errors} error{uploadResults.errors > 1 ? "s" : ""} with the imported file. The following row{uploadResults.errors > 1 ? "s were" : " was"} not saved.
                        <div className="table-responsive" style={{ marginBottom: 20 }}>
                            <table className="js-table-sections table table-hover">
                                <thead>
                                    <tr>
                                        <th>Row</th>
                                        <th>Error</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {uploadResults?.processed?.filter(i => i.error)?.map(item => <ImportLeaveAdjustmentRow item={item} />)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) || <></>}
                {(uploadResults?.warnings &&
                    <div>
                        We identified {uploadResults.warnings} potential mistake{uploadResults.warnings > 1 ? "s" : ""} with the imported file.
                        <div className="table-responsive" style={{ marginBottom: 20 }}>
                            <table className="js-table-sections table table-hover">
                                <thead>
                                    <tr>
                                        <th>Row</th>
                                        <th>Warning</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {uploadResults?.processed?.filter(i => i.warnings)?.map(item => <ImportLeaveAdjustmentRow item={item} />)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) || <></>}
                <button className="btn btn-default pull-right" onClick={showImportModal} style={{ marginBottom: 10 }}>Close</button>
                {uploadResults.errors || uploadResults.warnings ? <CSVLink filename="Leave Import Errors.csv" className="btn btn-success pull-right" style={{ marginBottom: 10, marginRight: 10 }} data={errors}><ArrowDownTrayIcon className='w-6 h-6 mr-3' style={{ verticalAlign: "text-bottom" }} />Download Error Report</CSVLink> : ""}
                <div className="clearfix" />
            </div>
        )
    }

    if (!isModalOpen) return null;

    return (
        <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}>
            <div className="modal-dialog" style={{ width: "50%" }}>
                <div className="modal-content">
                    <div className="block block-themed block-transparent remove-margin-b" style={{ padding: 0 }}>
                        <div className="block-header bg-primary-dark" style={{ padding: 20, position: 'sticky', top: 0, zIndex: 50 }}>
                            <ul className="block-options">
                                <li>
                                    <button type="button" onClick={showImportModal}>
                                        <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                                    </button>
                                </li>
                            </ul>
                            <h3 className="block-title">Import Leave Adjustments</h3>
                        </div>
                        <div className="block-content" style={{ marginRight: "30px", marginLeft: "30px", marginTop: "10px" }}>
                            <ImportLeaveStatus />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        uploadResults: state.leaveAdjustmentImport?.results || {},
        isModalOpen: state.leaveAdjustmentImport?.showModal,
        processing: state.leaveAdjustmentImport?.processingFile,
        uploading: state.leaveAdjustmentImport?.uploading,
        uploadTemplate: state.leaveAdjustmentImport?.template,
        uploadKey: state.leaveAdjustmentImport?.uploadResults,
        org: state.company?.settings?.org,
    }
}

const mapDispatchToProps = dispatch => ({
    uploadFile: (file) => dispatch(LEAVEADJUSTMENTACTIONS.uploadFile({ file })),
    handleLeaveAdjustmentUpload: ({ uploadKey, org, replaceExisting }) => dispatch(LEAVEADJUSTMENTACTIONS.handleLeaveAdjustmentUpload({ key: uploadKey, org, replaceExisting })),
    getLeaveAdjustmentImportTemplate: () => dispatch(LEAVEADJUSTMENTACTIONS.getLeaveAdjustmentImportTemplate()),
    showImportModal: () => dispatch(LEAVEADJUSTMENTACTIONS.showImportModal(false)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImportLeaveAdjustmentModal)